import { render, staticRenderFns } from "./saleOrderIcon.vue?vue&type=template&id=0da2b3e2&scoped=true"
import script from "./saleOrderIcon.vue?vue&type=script&lang=js"
export * from "./saleOrderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2b3e2",
  null
  
)

export default component.exports